// extracted by mini-css-extract-plugin
module.exports = {"container":"Review_container__3KZQk","quote":"Review_quote__J9Hcq","quote_line":"Review_quote_line__32CsP","user":"Review_user__2g5r_"};